module.exports = __webpack_public_path__ + "static/media/outdoor_education.544c267d.png";